import { parseDefaultTableColumns, TableColumn } from '../../../../context/shared/tableColumns';
import { Translation } from '../../../../domain/translation/Translation';

export const translationsTableColumnKeys = [`key`, `original_value`, `value`, `auto_translate`, `created_at`] as const;

export type TranslationsTableColumnKeys = (typeof translationsTableColumnKeys)[number];

export type TranslationsTableColumn = TableColumn<TranslationsTableColumnKeys, Translation>;

export const TRANSLATIONS_DEFAULT_TABLE_COLUMNS: Array<TranslationsTableColumn> = [
  {
    identifier: `key`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `original_value`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `value`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `auto_translate`,
    type: `boolean`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `created_at`,
    type: `Date`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
];

export const getTranslationsTableColumns = (): Array<TranslationsTableColumn> => {
  const storedTableColumns = localStorage.getItem(`BACKOFFICE_TRANSLATIONS_TABLE_COLUMNS`);
  if (!storedTableColumns) return TRANSLATIONS_DEFAULT_TABLE_COLUMNS;

  const parsedTableColumns = JSON.parse(storedTableColumns);

  // Final table columns should have the current ones.
  const finalTableColumns: Array<TranslationsTableColumn> = [
    ...(Array.isArray(parsedTableColumns) ? parsedTableColumns : []),
  ];

  return parseDefaultTableColumns({
    finalTableColumns,
    defaultTableColumns: TRANSLATIONS_DEFAULT_TABLE_COLUMNS,
  });
};

export const setTranslationsTableColumns = (tableColumns: Array<TranslationsTableColumn>) => {
  localStorage.setItem(`BACKOFFICE_TRANSLATIONS_TABLE_COLUMNS`, JSON.stringify(tableColumns));
};
